import { Country } from '@dreryk/address-common-api';

import { BindingCreator } from '@dreryk/react-common';
import { CountrySelect } from '@dreryk/react-components';

const COUNTRY_FIELD_NAME = 'country';

export type CountryFormBeanPart = {
   [COUNTRY_FIELD_NAME]: Country;
};

type CountryFieldProps = {
   readonly disabled: boolean | undefined;
   readonly register: BindingCreator<CountryFormBeanPart, typeof COUNTRY_FIELD_NAME>;
};

export const CountryField = (props: CountryFieldProps): JSX.Element => {
   return (
      <CountrySelect
         controller={props.register(COUNTRY_FIELD_NAME, {
            required: true,
         })}
         disabled={props.disabled}
         testId={COUNTRY_FIELD_NAME}
      />
   );
};
